<template>
  <div style="height: 60vh">
      <div style="height: 100%;" class="bad-scroll">
        <table class="table-wrapper" style="height:100%">
          <thead>
            <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
              <th style="width:12%"></th>
              <th style="width:50%">Why-why 分析流程</th>
              <th style="width:20%">措施对策</th>
              <th style="width:8%">责任人</th>
              <th style="width:8%">截止日期</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(plan,i) in dataList">
              <tr style="font-size:13px;">
              <td>{{plan.title}}</td>
              <td style="text-align:left;">
                <template v-if="plan.desc && plan['desc'].indexOf('data:image') > -1">
                  <img style="height:100%;width:100%" :src="plan.desc"/>
                </template>
                <template v-else>
                  <div style="margin:10px"><span v-html="feedFormat(plan.desc)"></span></div>
                </template>
              </td>
              <td style="text-align:left;padding:10px;"><span v-html="feedFormat(plan.plan)"></span></td>
              <td><span v-html="feedFormat(plan.owner)"></span></td>
              <td><span v-html="feedFormat(plan.dueDate)"></span></td>
            </tr>
            <!-- <tr style="font-size:13px;">
              <td>为什么没有发现？</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr style="font-size:13px;">
              <td>为什么没在系统里避免？</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr> -->
            </template>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "fr3d",
    props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["plans"]) {
          this.dataList = val["plans"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList:[],
      startCharts: null,
    };
  },
  mounted() {},
  methods: {
    formatDate(time) {
      if (time && time!='') {
        var date = new Date(Number(time));
        return format(date, "yyyy.MM.dd");
      }
      return "";
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    feedFormat(txt){
        if(txt && typeof txt === 'string'){
            return txt.replaceAll("\t", "&nbsp;&nbsp;").replaceAll("\n", "<br/>");
        }
        return txt;
    }

  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper > thead > tr > th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 12px;
  min-width:50px;
  font-size: 16px;
}

.table-wrapper > tbody > tr > td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  text-align: center;
  font-size: 16px;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #909090;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/5why/component/2d.vue